const features = [
  { icon: 'ri-shield-check-line', gradient: 'from-emerald-500 via-teal-500 to-cyan-500', title: 'Satisfaction Guarantee or Refund', desc: '7 days to test, full refund if not satisfied' },
  { icon: 'ri-flashlight-line', gradient: 'from-amber-400 via-yellow-500 to-orange-500', title: 'Instant Activation', desc: 'Receive your access in less than 5 minutes after payment' },
  { icon: 'ri-customer-service-2-line', gradient: 'from-pink-500 via-[#862ce0] to-[#c026d3]', title: 'VIP Support 7 days/7', desc: 'Technical assistance available from 10am to 12am every day' },
  { icon: 'ri-replay-10-line', gradient: 'from-cyan-500 via-blue-500 to-indigo-600', title: '7-Day Replay', desc: 'Rewatch your shows from the last 7 days whenever you want' },
  { icon: 'ri-refresh-line', gradient: 'from-violet-500 via-purple-500 to-fuchsia-500', title: 'Automatic Updates', desc: 'New channels and content added regularly' },
  { icon: 'ri-spam-2-line', gradient: 'from-green-500 via-emerald-500 to-teal-500', title: 'Anti-Freeze Technology', desc: 'Optimised servers for seamless streaming' },
  { icon: 'ri-4k-line', gradient: 'from-orange-500 via-[#862ce0] to-pink-500', title: '4K Ultra HD Quality', desc: 'Crystal clear image on all your favourite channels' },
];

const WhyChoose = () => (
  <section id="avantages" className="py-12 sm:py-16 md:py-20 bg-gray-950">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10 sm:mb-12 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">Why Choose 4K Dream?</h2>
        <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto">Discover all the advantages that make 4K Dream a trusted choice for premium streaming</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {features.map((f) => (
          <div key={f.title} className="bg-gray-900/50 border border-gray-800 hover:border-gray-600 transition-all duration-300 hover:scale-105 rounded-lg group">
            <div className="p-5 sm:p-6 text-center">
              <div className={`bg-gradient-to-r ${f.gradient} w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-all duration-300`}>
                <i className={`${f.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2">{f.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChoose;
